import { api } from '../api';

const createFleetLoadBalance = async ({ request }) => {
  const response = await api({
    url: `Vehicles/createFleetLoadBalance`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const createFleetLoadBalanceSuccess = async ({ request }) => {
  const response = await api({
    url: `Vehicles/order`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data: request,
  });
  return response.data;
};

const addFleetLimitServices = {
  createFleetLoadBalance,
  createFleetLoadBalanceSuccess,
};

export default addFleetLimitServices;
